// src/components/Sections/HomeHeader/HomeHeader.jsx

import React from 'react';
import './HomeHeader.scss';
import logo from '../../../assets/images/logo.png';

const navigation = [
  { label: 'The Club', href: '#club' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Groups', href: '#groups' },
  { label: 'Tour Series', href: '#tournaments' },
  { label: 'Membership', href: '#pricing' }
];

export default function HomeHeader({
  mobileMenuOpen,
  setMobileMenuOpen,
  closeMobileMenu
}) {
  return (
    <header className={`site-header ${mobileMenuOpen ? 'is-open' : ''}`}>
      <div className="container header__inner">
        <a
          href="#hero"
          className="brand"
          aria-label="The Tour Golfers Home"
          onClick={closeMobileMenu}
        >
          <img src={logo} alt="" className="brand__icon" />

          <span className="brand__name">The Tour Golfers</span>
        </a>

        <nav className="nav-desktop" aria-label="Main Navigation">
          {navigation.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <a href="#pricing" className="desktop-header-cta">
          Request Membership
        </a>

        <button
          className="hamburger"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-navigation"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div
        id="mobile-navigation"
        className={`nav-mobile ${mobileMenuOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile menu"
      >
        {navigation.map((item) => (
          <a key={item.href} href={item.href} onClick={closeMobileMenu}>
            {item.label}
          </a>
        ))}

        <a href="#pricing" className="nav-cta" onClick={closeMobileMenu}>
          Request Membership
        </a>
      </div>

      <button
        className="nav-overlay"
        aria-label="Close menu"
        onClick={closeMobileMenu}
        type="button"
      ></button>
    </header>
  );
}
